const allocation = `${process.env.VUE_APP_URL}/api/v1/allocation/dimension-allocations/`;
const allocationCalculation = `${process.env.VUE_APP_URL}/api/v1/calculation`;
const dimensions = `${process.env.VUE_APP_URL}/api/v1/dimensions`;

import { validateResponseError } from "@/store/utils.js";
export default {
  namespaced: true,
  state: {
    getOptionLabelMethod: (option) => { return `${option.source_activity_name}: ${option.source_parent_name} -> ${option.destination_child_name}` },
    reduceChosenOption: (act) => {
      return { activity: act.source_activity, source: act.source_parent, destination: act.destination_child };
    },
    reduceActivityChosenOption: (act) => { return act.id },
    reduceDimensionChosenOption: (dim) => { return dim.id },
    unallocatedResults: false,
    management: {
      baseUrl: ({ scenario, limit, offset }) => `${allocation}?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Activity Source",
          field: "source_activity_name",
        },
        {
          label: "Dimension Source",
          field: "source_parent_name",
        },
        {
          label: "Dimension Destination",
          field: "destination_child_name",
        },
        {
          label: "Formula",
          field: "equation",
        },
        {
          label: "",
          field: "manage",
        },
      ],
      rows: [],
    },
    parentToChild: {
      columnUrl: (model) => `${dimensions}/get-labels/?model=${model}`,
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/dimension-results/get-parent-to-child-rows/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [],
      rows: [],
    },
    childToParent: {
      columnUrl: (model) => `${dimensions}/get-labels/?model=${model}`,
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/dimension-results/get-child-to-parent-rows/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [],
      rows: [],
    },
    byLine: {
      baseUrl: ({ params, limit, offset }) => `${allocationCalculation}/dimension-results/?limit=${limit}&${params}${offset}`,
      baseUrlUnallocated: ({ params, limit, offset }) => `${allocationCalculation}/dimension-results-unallocated/?limit=${limit}&${params}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Transaction ID",
          field: "transaction_id",
          hidden: false,
        },
        {
          label: "Category",
          field: "category",
          hidden: false,
        },
        {
          label: "Allocated cost",
          field: "amount",
          type: 'number',
          hidden: false,
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
        {
          label: "Time Driven Amount",
          field: "time_driven_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
      ],
      rows: [],
    },
    /////////////////////////////////////////////////////////////////////////////////////////////////

    editAllocationForm: {
      equation: "=",
      splitType: "NOT_ALLOCATE",
      allocationDriver: null
    },
    currentDimensionDrivers: [],

    lastCalculation: [{
      calculation_id: null,
      finished_at: null, 
      requested_by_user: null,
    }],

    resultsOptionsByLine: [], // Options on by-line

    activityByLine: null,

    dimensionByLine: null,

    categoryByLine: null,
    debug:{
      mode: "logs",
      errors:[],
      logs:[]
    }
  },
  getters:{
    getDebugData(state){
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_ALLOCATED_NOT_ALLOCATED(state, data) {
      state.unallocatedResults = data;
    },
    SET_OFFSET(state, data) {
      state[data.subStore].offset = state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength < 0 ? 0 : state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength
    },
    SET_ALLOCATION_EQUATION(state, data) {
      state.editAllocationForm.equation = data;
    },
    SET_ALLOCATION_SPLIT_TYPE(state, data) {
      state.editAllocationForm.splitType = data;
    },
    SET_ALLOCATION_DRIVER(state, data) {
      state.editAllocationForm.allocationDriver = data;
    },
    CLEAR_ALLOCATION_FORM(state) {
      state.editAllocationForm = state
    },
    SET_EDIT_ALLOCATION_FORM_DATA(state, data) {
      state.editAllocationForm = data;
    },
    SET_DIMENSION_DRIVERS(state, data) {
      state.currentDimensionDrivers = data;
    },

    SET_LAST_CALCULATION(state, data) {
      if(!data){
        return;
      }
      state.lastCalculation = data;
    },
    CLEAR_RESULTS_DATA(state) {
      state.parentToChild.rows = [];
      state.parentToChild.columns = [];
      state.childToParent.rows = [];
      state.childToParent.columns = [];
      state.byLine.rows = [];
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },
    SET_RESULTS_OPTIONS_BY_LINE(state, data) {
      state.resultsOptionsByLine = data;
    },
    SET_RESULTS_BY_LINE(state, data) {
      state.resultsByLineRows = data;
    },

    CLEAR_BY_LINE_RESULTS(state) {
      state.resultsByLineRows = [];
      state.resultsOptionsByLine = [];
      state.categoryByLine = null;
      state.dimensionByLine = null;
      state.activityByLine = null;
    },
    SET_DIMENSION(state, data) {
      state.dimensionByLine = data;
      state.byLine.currentUrl = null;
    },
    SET_ACTIVITY(state, data) {
      state.activityByLine = data;
      state.byLine.currentUrl = null;
    },
    SET_CATEGORY(state, data) {
      state.categoryByLine = data;
      state.byLine.currentUrl = null;
    },
    SET_BY_LINE_COLUMNS_TDABC(state, data) {
      state.byLine.columns.forEach(element => {
        if (element.label == "Time Driven Amount") { element.hidden = !data }
        if (element.label == "Capacity") { element.hidden = !data }
      });      
    },
    SET_BY_LINE_COLUMNS_UNALLOCATED(state,) {    
      let originalData = [
        {
        label: "Original Dimension",
        field: "original_dimension_name",
        hidden: false,
        },
        {
          label: "Original Transaction ID",
          field: "original_transaction_id",
          hidden: false,
        }
      ]
      if (state.unallocatedResults){
        if(!state.byLine.columns.some(item => item.label === "Original Dimension")){
          state.byLine.columns.unshift(...originalData)
        }
      }else{
        state.byLine.columns = state.byLine.columns.filter(item => item.label !== "Original Dimension")
        state.byLine.columns = state.byLine.columns.filter(item =>  item.label !== "Original Transaction ID")
      }
    },

    /////////////////////////////////////////////////////////
    SET_COUNT(state, data) {
      state[data.subStore].count = data.count;
    },
    SET_NEXT(state, data) {
      state[data.subStore].nextUrl = data.next;
    },
    SET_PREVIOUS(state, data) {
      state[data.subStore].previousUrl = data.previous;
    },
    SET_CURRENT(state, data) {
      state[data.subStore].currentUrl = data.current;
    },
    SET_ROWS(state, data) {
      if(!data.rows){
        return;
      }
      let copy = { ...state[data.subStore] }
      copy.rows = data.rows;
      state[data.subStore] = copy;
    },
    SET_PAGE_LENGTH(state, data) {
      state[data.subStore].pageLength = data.pageLength;
    },

    SET_COLUMNS(state, data) {
      state[data.subStore].columns = data.columns.map(column => { return { ...column, field: `${column.id}` } });
    },

    CLEAR_TABLE_DATA(state, data){
      if(data.subStore){
        state[data.subStore].rows = [];

        if(data.subStore == "parentToChild" || data.subStore=="childToParent"){
          state[data.subStore].columns = [];
        }
      }
    },
    SET_DEBUG_LOGS(state, data){
      state.debug.logs = data;
    },
    SET_DEBUG_ERRORS(state, data){
      state.debug.errors = data;
    },
    SET_DEBUG_MODE(state, data){
      state.debug.mode = data;
    },
  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId, modelId, subStore, allocation, isTdabc }) {
      if ("columnUrl" in state[subStore]) {
        context.$http.get(state[subStore].columnUrl(modelId)).then((res) => {
          let drivers = res.data.map(driver => (driver.id=="key_table_id" ? {...driver} : { ...driver, type: 'number', formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; } }))
          commit("SET_COLUMNS", { subStore, columns: drivers });
        });
      }
      let paramObj = {};
      paramObj.scenario = scenarioId;
      if (state.categoryByLine) {
        paramObj.category = state.categoryByLine;
      }
      if (state.activityByLine) {
        paramObj.source = state.activityByLine;
      }
      if (state.dimensionByLine) {
        paramObj.dimension = state.dimensionByLine;
      }
      let params = new URLSearchParams(paramObj);
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      let getData
      if(state.unallocatedResults && subStore=="byLine"){
        getData =
          state[subStore].currentUrl || state[subStore].baseUrlUnallocated({ params: params, scenario: scenarioId, limit: state[subStore].pageLength, offset: offset, calculationId: state.lastCalculation.calculation_id, allocation: allocation });
        }else{
        getData =
          state[subStore].currentUrl || state[subStore].baseUrl({ params: params, scenario: scenarioId, limit: state[subStore].pageLength, offset: offset, calculationId: state.lastCalculation.calculation_id, allocation: allocation });
      }

      return context.$http.get(getData).then((res) => {
        commit("SET_COUNT", { subStore, count: res.data.count });
        commit("SET_NEXT", { subStore, next: res.data.next });
        commit("SET_PREVIOUS", { subStore, previous: res.data.previous });
        commit("SET_ROWS", { subStore, rows: res.data.count ? res.data.results : res.data });
        if(subStore === "byLine") {
          commit("SET_BY_LINE_COLUMNS_TDABC", isTdabc)
          commit("SET_BY_LINE_COLUMNS_UNALLOCATED");
        };
      });
    },
    setNextAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].nextUrl });
    },
    setPreviousAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].previousUrl });
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////

    getCurrentDimensionDrivers({ state, commit }, { context }) {
      context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/drivers?dimension=${state.editAllocationForm.destination_child}&driver_type=decimal`
      )
        .then((res) => {
          commit("SET_DIMENSION_DRIVERS", res.data.items);
        });
    },
    updateFifthAllocation({ state }, { context }) {
      const formulaConstructor = {
        EVEN: () => { return "EVEN"; },
        NOT_ALLOCATE: () => { return "NOT_ALLOCATE"; },
        DRIVER: () => { return `DRIVER:${state.editAllocationForm.allocationDriver}` },
        FORMULA: () => { return state.editAllocationForm.equation }
      }

      let dataToPost = { equation: formulaConstructor[state.editAllocationForm.splitType]() };
      let putUrl = `${allocation}${state.editAllocationForm.id}/`;
      return context.$http.patch(putUrl, dataToPost);
    },
    getLastCalculationDetails({ commit, dispatch, state }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACTIVITY_TO_DIMENSION_INDIRECT`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        })
        .catch(err => {
          validateResponseError(this, err, "fifthAllocation");
        })
    },
    getLastCalculation({ commit, dispatch, state }, { context, scenarioId, modelId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACTIVITY_TO_DIMENSION_INDIRECT`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "fifthAllocation");
        })
    },
    calculateResults({ dispatch, commit, state }, { context, scenarioId, modelId }) {
      let resultsUrl = `${allocationCalculation}/dimension-results/generate/`;
      return context.$http.post(resultsUrl, { scenario: scenarioId })
        .then(res => {
          commit("CLEAR_RESULTS_DATA");
          commit("SET_LAST_CALCULATION", [res.data])
        });
    },
    getParentChildResults({ dispatch }, { context, modelId, scenarioId }) {
      dispatch("getTableData", { context, subStore: "parentToChild", scenarioId: scenarioId, modelId: modelId })
    },
    getChildParentResults({ dispatch }, { context, modelId, scenarioId }) {
      dispatch("getTableData", { context, subStore: "childToParent", scenarioId: scenarioId, modelId: modelId })
    },
    getAggregatedByLineAllocationResults({ dispatch }, { context, scenarioId, isTdabc }) {
      dispatch("getTableData", { context, subStore: "byLine", scenarioId: scenarioId, isTdabc:isTdabc })
    },
    getDimensionAllocationResults({ commit }, { context, scenarioId }) {
      let allocations = `${allocationCalculation}/dimension-results/?scenario=${scenarioId}`
      return context.$http.get(allocations)
        .then(res => {
          commit("SET_RESULTS_OPTIONS_BY_LINE", res.data);
        })
    },
    getCalculationLogs({commit, state},{context}){
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/calculation/logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail )
        }).catch(err => {
          validateResponseError(this, err, "fifthAllocation");
        })
    },
    getCalculationErrors({commit},{}){
      commit("SET_DEBUG_ERRORS",["Not implemented"]);
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl =  `${allocationCalculation}/calculations/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
  },
}
